import { showStatus } from './AxiosReqs';
import { saveCart } from './cart';

export const handlePayments = async (products, address) => {
  let res;
  try {
    res = await axios({
      method: 'POST',
      url: '/api/v1/orders/create-order',
      data: {
        products,
        address,
      },
    });
  } catch (error) {
    console.log(error);
    showStatus('fail', 'Payments Unavailable');
  }

  if (res.data.status !== 'success') {
    showStatus('fail', 'Failed to Process Order');
    console.log('Failed to create order', res.data);
    return;
  }

  // * EXTRACTING NECESSARY DATA
  const { razorpayOrderId, orderId, amount, currency } = res.data.data;

  // ! RAZORPAY LOADED CHECK
  if (typeof Razorpay === 'undefined') {
    console.log('Razorpay SDK not loaded');
    showStatus('fail', 'Razorpay SDK not loaded');
    return;
  }

  // * ✅ Razorpay Initialization
  const options = {
    key: 'rzp_live_RA0RwrdkS8yPfY',
    amount: amount,
    currency: currency,
    name: 'DM Sales',
    description: 'Order Payment',
    order_id: razorpayOrderId,
    handler: async function (response) {
      // Step 3: Verify Payment with backend
      const verifyRes = await fetch('/api/v1/orders/payment-success', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          razorpay_order_id: razorpayOrderId, // ✅ Use correct key names
          razorpay_payment_id: response.razorpay_payment_id,
          razorpay_signature: response.razorpay_signature,
        }),
      });

      const verifyData = await verifyRes.json();

      if (verifyData.status === 'success') {
        showStatus('success', 'Payment Successful!');
        saveCart([]);
        window.setTimeout(() => location.assign(`/orders`), 1500);
      } else {
        showStatus('fail', 'Payment Failed!');
        alert('Payment Failed!');
      }
    },
    theme: { color: '#1641af' },
  };

  const rzp = new Razorpay(options);
  rzp.open();
};
